@import '../../../../constants/spacing.module.less';
@import '../../../../constants/z-index.module.less';
@import '~style-sheet-helpers/core.less';

@popover-card--box-shadow:
  0 49px 14px 0 rgba(0, 0, 0, 0),
  0 31px 13px 0 rgba(0, 0, 0, 0.01),
  0 18px 11px 0 rgba(0, 0, 0, 0.05),
  0 8px 8px 0 rgba(0, 0, 0, 0.09),
  0 2px 4px 0 rgba(0, 0, 0, 0.1);

.card {
  width: 320px;
  border: 1px solid var(--gray-A4ABB6);
  border-radius: 8px;
  box-shadow: @popover-card--box-shadow;
  overflow: hidden;
}

.close-button {
  position: absolute;
  top: @space-8;
  right: @space-8;
  color: var(--gray-56595D);
  font-size: 14px;
  padding: @space-4;
  line-height: 1;

  &:hover {
    color: var(--gray-0F0F10);
  }
}

.image-area {
  background-color: var(--blue-EDF6FF, #edf6ff);
  border-bottom: 1px solid var(--gray-E1E4E8);
  overflow: hidden;
}

.illustration {
  width: 100%;
  height: auto;
  display: block;
}

.body {
  background: @white;
  padding: @space-16;
}

.recommended-badge {
  background-color: var(--blue-1D5AD8);
  color: @white;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  min-height: unset;
  padding: @space-4 @space-12;
  border-radius: 100px;
  white-space: nowrap;
  width: fit-content;
}

.card-actions {
  justify-content: space-between;
  align-items: center;
  padding-right: @space-16;
}

.learn-more-icon {
  font-size: 12px;
  margin-left: @space-4;
}

.popover-arrow {
  border-color: var(--gray-A4ABB6);
}
